var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactPhoneBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1590_7932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 21C1.45 21 0.979333 20.8043 0.588 20.413C0.196667 20.0217 0.000666667 19.5507 0 19V5C0 4.45 0.196 3.97933 0.588 3.588C0.98 3.19667 1.45067 3.00067 2 3H22C22.55 3 23.021 3.196 23.413 3.588C23.805 3.98 24.0007 4.45067 24 5V19C24 19.55 23.8043 20.021 23.413 20.413C23.0217 20.805 22.5507 21.0007 22 21H2ZM9 14C9.83333 14 10.5417 13.7083 11.125 13.125C11.7083 12.5417 12 11.8333 12 11C12 10.1667 11.7083 9.45833 11.125 8.875C10.5417 8.29167 9.83333 8 9 8C8.16667 8 7.45833 8.29167 6.875 8.875C6.29167 9.45833 6 10.1667 6 11C6 11.8333 6.29167 12.5417 6.875 13.125C7.45833 13.7083 8.16667 14 9 14ZM19 18L21 16L19.5 14H17.85C17.75 13.7 17.6667 13.3793 17.6 13.038C17.5333 12.6967 17.5 12.3507 17.5 12C17.5 11.6493 17.5333 11.312 17.6 10.988C17.6667 10.664 17.75 10.3347 17.85 10H19.5L21 8L19 6C18.1 6.7 17.375 7.58767 16.825 8.663C16.275 9.73833 16 10.8507 16 12C16 13.1493 16.275 14.262 16.825 15.338C17.375 16.414 18.1 17.3013 19 18ZM2.1 19H15.9C15.2 17.75 14.2333 16.771 13 16.063C11.7667 15.355 10.4333 15.0007 9 15C7.56667 14.9993 6.23333 15.3537 5 16.063C3.76667 16.7723 2.8 17.7513 2.1 19Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1590_7932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhoneBlack);
export default __webpack_public_path__ + "static/media/contact-phone-black.16be7e4d28afe7eae62e5306434648a4.svg";
export { ForwardRef as ReactComponent };